var _rect, _path, _path2, _rect2, _path3, _rect3, _path4, _rect4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWell1Img(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.07227,
    y: 0.862305,
    width: 26.6667,
    height: 36.6667,
    rx: 3.33333,
    fill: "#070C1A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.833252 4.19564C0.833252 2.35469 2.32564 0.862305 4.16659 0.862305H24.1666C26.0075 0.862305 27.4999 2.35469 27.4999 4.19564V31.257L21.3461 37.529H4.16659C2.32564 37.529 0.833252 36.0366 0.833252 34.1956V4.19564Z",
    fill: "#65A5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3638 31.251H27.5005L21.3638 37.5205V31.251Z",
    fill: "#070C1A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3333,
    y: 8.10449,
    width: 10.0952,
    height: 2.5,
    rx: 1.25,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.99215L6.8212 10.8192L10.4286 7.2002",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3333,
    y: 17.2686,
    width: 10.0952,
    height: 2.5,
    rx: 1.25,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90552 18.0332L6.72672 19.8603L10.3341 16.2412",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3333,
    y: 25.5986,
    width: 10.0952,
    height: 2.5,
    rx: 1.25,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90552 26.1757L6.72672 28.0028L10.3341 24.3838",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7908 15.7959L34.3095 18.7485L24.4766 30.4669L20.9579 27.5143L30.7908 15.7959Z",
    fill: "#00A661"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.425 13.8408L35.9438 16.7934L34.305 18.7465L30.7862 15.7939L32.425 13.8408Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6829 12.3424C34.4982 11.3707 35.9469 11.244 36.9186 12.0593C37.8902 12.8746 38.017 14.3233 37.2016 15.295L35.9466 16.7907L32.4278 13.8381L33.6829 12.3424Z",
    fill: "#00A661"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0208 33.3871L20.9075 27.4818L24.5089 30.5037L19.0208 33.3871Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8918 33.5495L19.5005 31.9802L20.3316 32.6775L18.8918 33.5495Z",
    fill: "#070C1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWell1Img);
export default __webpack_public_path__ + "static/media/well-1-img.0e56ac77067e80a7f0c6cd815cc13594.svg";
export { ForwardRef as ReactComponent };